import React from 'react';
import { Navbar } from './components/Navbar';
import { Hero } from './components/Hero';
import { Problems } from './components/Problems';
import { AboutMe } from './components/AboutMe';
import { Method } from './components/Method';
import { Offerings } from './components/Offerings';
import { LeadMagnet } from './components/LeadMagnet';
import { Testimonials } from './components/Testimonials';
import { FooterCTA } from './components/FooterCTA';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen bg-pearl flex flex-col pt-16" data-id="element-0">
      <Navbar data-id="element-1" />
      <Hero data-id="element-2" />
      <Problems data-id="element-3" />
      <AboutMe data-id="element-4" />
      <Method data-id="element-5" />
      <Offerings data-id="element-6" />
      <LeadMagnet data-id="element-7" />
      <Testimonials data-id="element-8" />
      <FooterCTA data-id="element-9" />
      <Footer data-id="element-10" />
    </div>;
}